import {
  generateMutationTypes,
  createInitialState,
  createGetters,
  createMutations,
  createCrudActions,
} from './storeFactory';
import citizenComplaintsAPI from '../../api/captain/citizenComplaints';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const mutationTypes = generateMutationTypes('CITIZEN_COMPLAINTS');

const state = {
  ...createInitialState(),
  stats: {},
};

// Extend uiFlags with stats flag
state.uiFlags.fetchingStats = false;

const getters = {
  ...createGetters(),
  getStats: s => s.stats,
};

const mutations = {
  ...createMutations(mutationTypes),
  SET_STATS(s, stats) {
    s.stats = stats;
  },
};

const actions = {
  ...createCrudActions(citizenComplaintsAPI, mutationTypes),
  fetchStats: async ({ commit }, params = {}) => {
    commit(mutationTypes.SET_UI_FLAG, { fetchingStats: true });
    try {
      const response = await citizenComplaintsAPI.getStats(params);
      commit('SET_STATS', response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { fetchingStats: false });
    }
  },
  archive: async ({ commit }, id) => {
    commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
    try {
      const response = await citizenComplaintsAPI.archive(id);
      commit(mutationTypes.EDIT, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
    }
  },
  addNote: async ({ commit }, { id, content }) => {
    commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
    try {
      const response = await citizenComplaintsAPI.addNote(id, content);
      commit(mutationTypes.EDIT, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
